import { Helper } from "@helpers/functions";
import { getLocaleArray, truncate } from "@helpers/utils";

// TODO: eslint fix (Consider to refactor)
/* eslint-disable @typescript-eslint/no-explicit-any */
export function isTrueProperty(val: any): boolean {
	if (typeof val === "string") {
		val = val.toLowerCase().trim();
		return val === "true" || val === "on" || val === "";
	}
	if (typeof val === "number") {
		return val === 1;
	}

	return !!val;
}

export function round(num: number, precision: number, ignorePrecision: boolean = false): string {
	const locales: string[] = getLocaleArray(Helper.getLanguage());

	return (ignorePrecision ? num : truncate(num, precision)).toLocaleString(locales, {
		localeMatcher: "best fit",
		minimumIntegerDigits: 1,
		minimumFractionDigits: precision,
		maximumFractionDigits: 8
	});
}
